import styled from 'styled-components';
import { animated } from 'react-spring';

const Outer = styled(animated.div)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${({ theme }) => theme.colors.splashBackground};
  height: 100vh;
  width: 100%;
  z-index: 9999;
  margin: 0;
  overflow: hidden;
`;

export default Outer;
